// extracted by mini-css-extract-plugin
export var text = "_l-0";